import { Engagement } from '../admin/types';

export function isEngagementActive(engagement: Engagement): boolean {
  return !engagement.endDate;
}